module.exports = "\n\n\n<h3 *ngIf=\"message\">{{message}}</h3>\n\n<div *ngIf=\"html\" [innerHTML]=\"html | trustHtml\"></div>\n\n<div mat-dialog-actions>\n  <button mat-button [mat-dialog-close]=\"true\">OK</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/components/ok-dialog/ok-dialog.component.html
// module id = ../../../../../src/app/admin-area/components/ok-dialog/ok-dialog.component.html
// module chunks = main